// @ts-strict-ignore
import * as React from 'react';

import { NEEDL_BOOKMARK_TAG } from '@/components/UserTags/common';
import type {
  OnSuccessProps,
  Option,
} from '@/components/UserTags/TagAutocomplete/types';

import { useMutateDocumentTag } from './useMutateDocumentTag';

export const useTagHandler = ({ deeplink }) => {
  const mutate = useMutateDocumentTag(deeplink);

  return React.useCallback(
    ({ tags, board_id, channel_id, isBookmarked }: OnSuccessProps) => {
      mutate.mutate({
        tags: tags
          .map((option: Option) => {
            if (typeof option === 'string') {
              return option;
            }
            if (option.inputValue) {
              return option.inputValue;
            }
            throw new Error('Unexpected option type');
          })
          .concat(isBookmarked ? [NEEDL_BOOKMARK_TAG] : []),
        channelId: channel_id,
        feedId: board_id,
        isBookmarked,
      });
    },
    [mutate]
  );
};
